<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="pt01"><a id="page_1"></a><strong><em>Part I</em><br/>Sephardic Jewry in the Middle Ages<br/><em>Origins, Development, and Flowering</em></strong><a id="page_2"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pt01.vue?272b30dc